<script setup>
import { ref, reactive, watch, computed, onMounted } from 'vue'
import { EaseChatClient } from '@/IM/initwebsdk'
import { handleSDKErrorNotifi } from '@/utils/handleSomeData'
import {
    captchaImage,
    loginCustom,
    getImToken,
    getUserInfo
} from '@/api/custom'
import { useStore } from 'vuex'
import { usePlayRing } from '@/hooks'
import { ElMessage } from 'element-plus'
const store = useStore()
const loginValue = reactive({
    phoneNumber: '',
    smsCode: '',
    code: '',
    uuid: ''
})
const state = reactive({
    codeImg: ''
})
const buttonLoading = ref(false)
//根据登陆初始化一部分状态
const loginState = computed(() => store.state.loginState)
watch(loginState, (newVal) => {
    if (newVal) {
        buttonLoading.value = false
        loginValue.phoneNumber = ''
        loginValue.smsCode = ''
    }
})
const rules = reactive({
    phoneNumber: [
        { required: true, message: '请输入手机号', trigger: 'blur' },
        {
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入正确的手机号',
            trigger: ['blur', 'change']
        }
    ],
    smsCode: [
        {
            required: true,
            message: '请输入短信验证码',
            trigger: ['blur', 'change']
        }
    ]
})
onMounted(() => {
    // localStorage.clear() EASEIM_loginUser
    localStorage.removeItem('customToken')
    localStorage.removeItem('EASEIM_loginUser')
    getImg()
})
const getImg = () => {
    captchaImage().then((res) => {
        //console.log("%c Line:45 🍷 res", "color:#3f7cff", res);
        state.codeImg = 'data:image/gif;base64,' + res.img
        loginValue.uuid = res.uuid
    })
}
//登陆接口调用
const loginIM = async () => {
    const { clickRing } = usePlayRing()
    clickRing()
    buttonLoading.value = true
    // 先登录客户端服务器
    loginCustom(loginValue)
        .then(async (res) => {
            // 将客户端token保存在本地
            window.localStorage.setItem(
                'customToken',
                JSON.stringify(res.token)
            )
            if (res.code == 200) {
                // 获取IM token
                getImToken().then(async (res2) => {
                    // //console.log("%c Line:70 🍒 res2", "color:#ffdd4d", res2);
                    try {
                        // 获取个人资料
                        let userInfos = await getUserInfo()
                        window.localStorage.setItem(
                            `customUserInfo`,
                            JSON.stringify(userInfos.data)
                        )
                        // 用token登录IM
                        try {
                            let { accessToken } = await EaseChatClient.open({
                                user: userInfos.data.hxusername.toLowerCase(),
                                // pwd: userInfos.data.userName,
                                accessToken: res2.msg
                            })
                            window.localStorage.setItem(
                                `EASEIM_loginUser`,
                                JSON.stringify({
                                    user: userInfos.data.hxusername,
                                    accessToken: accessToken
                                })
                            )
                        } catch (error) {
                            //console.log('>>>>登陆失败', error);
                            const {
                                data: { extraInfo }
                            } = error
                            handleSDKErrorNotifi(error.type, extraInfo.errDesc)
                        } finally {
                            buttonLoading.value = false
                        }
                    } catch (er) {
                        //console.log("%c Line:93 🍧 er", "color:#7f2b82", er);
                    }
                })
            } else {
                getImg()
                buttonLoading.value = false
                ElMessage({
                    type: 'error',
                    message: res.msg,
                    center: true
                })
            }
        })
        .catch((err) => {
            getImg()
            buttonLoading.value = false
            let str = err.msg
            ElMessage({
                type: 'error',
                message: str,
                center: true
            })
        })
}
</script>

<template>
    <div class="login-container">
        <div class="login_title">登录</div>
        <el-form :model="loginValue" :rules="rules" label-position="top">
            <el-form-item label="账号" prop="username">
                <el-input
                    class="login_input_style"
                    v-model="loginValue.username"
                    placeholder="账号"
                    clearable
                />
            </el-form-item>
            <el-form-item label="密码" prop="password">
                <el-input
                    class="login_input_style"
                    type="password"
                    v-model="loginValue.password"
                    placeholder="密码"
                    clearable
                />
            </el-form-item>
            <el-form-item label="验证码" prop="code">
                <el-input
                    class="login_input_style"
                    v-model="loginValue.code"
                    placeholder="请输入验证码"
                    style="width: 313px"
                >
                </el-input>
                <img
                    v-if="state.codeImg"
                    :src="state.codeImg"
                    alt=""
                    style="
                        height: 40px;
                        width: 100px;
                        vertical-align: top;
                        margin-left: 20px;
                        cursor: pointer;
                    "
                    @click="getImg()"
                />
            </el-form-item>
            <el-form-item>
                <div class="function_button_box">
                    <el-button
                        v-if="
                            loginValue.username &&
                            loginValue.password &&
                            loginValue.code
                        "
                        class="haveValueBtn"
                        :loading="buttonLoading"
                        @click="loginIM"
                        >登录</el-button
                    >
                    <el-button v-else class="notValueBtn">登录</el-button>
                </div>
            </el-form-item>
        </el-form>
    </div>
</template>

<style lang="scss" scoped>
.login-container {
    width: 433px;
    height: 427px;
    border-radius: 20px 20px 20px 20px;
    background-color: #fff;
    padding: 33px;
    .login_title {
        font-weight: 600;
        font-size: 24px;
        color: #333333;
        text-align: center;
        margin-bottom: 33px;
    }
}

.login_input_style {
    margin: 6px 0;
    width: 433px;
    height: 44px;
    padding: 0 16px;
    border-radius: 10px 10px 10px 10px;
    background: #f6f6f6;
}

::v-deep .el-input__inner {
    // padding: 0 20px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 1.75px;
    color: #3a3a3a;

    &::placeholder {
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height */
        letter-spacing: 1.75px;
        color: #cccccc;
    }
}

::v-deep .el-input__suffix-inner {
    font-size: 20px;
    margin-right: 15px;
}

::v-deep .el-form-item__error {
    margin-left: 16px;
}

::v-deep .el-input-group__append {
    background: linear-gradient(90deg, #04aef0 0%, #5a5dd0 100%);
    width: 60px;
    color: #fff;
    border: none;
    font-weight: 400;

    button {
        font-weight: 300;
    }
}

.login_text {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    text-align: right;

    .login_text_isuserid {
        display: inline-block;
        // width: 100px;
        color: #f9f9f9;
    }

    .login_text_tologin {
        margin-right: 20px;
        width: 80px;
        color: #05b5f1;
        cursor: pointer;

        &:hover {
            text-decoration: underline;
        }
    }
}

.function_button_box {
    margin-top: 10px;
    width: 433px;

    button {
        margin: 10px 0;
        width: 433px;
        height: 50px;
        border-radius: 57px;
    }

    .haveValueBtn {
        // background: linear-gradient(90deg, #04aef0 0%, #5a5dd0 100%);
        border: none;
        font-weight: 300;
        font-size: 17px;
        color: #f4f4f4;
        border-radius: 10px !important;
        height: 44px;
        background-color: #3680FF;

        &:active {
            background: linear-gradient(90deg, #0b83b2 0%, #363df4 100%);
        }
    }

    .notValueBtn {
        border: none;
        font-weight: 300;
        font-size: 17px;
        background: #c9e2f8;
        mix-blend-mode: normal;
        color: #ffffff;
        cursor: not-allowed;
        border-radius: 10px !important;
        height: 44px;
    }
}

::v-deep .el-input__wrapper {
    display: inline-flex;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    background-color: #f6f6f6;
    background-image: none;
    border-radius: var(--el-input-border-radius, 57px);
    cursor: text;
    transition: var(--el-transition-box-shadow);
    transform: translate3d(0, 0, 0);
    box-shadow: none;
}

::v-deep .el-form-item__label {
    font-weight: 500;
    font-size: 16px;
    color: #000000;
}

::v-deep .el-form-item {
    margin-bottom: 12px !important;
}

::v-deep .el-input {
    --el-input-text-color: var(--el-text-color-regular);
    --el-input-border: #f6f6f6;
    --el-input-hover-border: #f6f6f6;
    --el-input-focus-border: #f6f6f6;
    --el-input-transparent-border: 0 0 0 1px transparent inset;
    --el-input-border-color: #f6f6f6;
    --el-input-border-radius: 57px;
    --el-input-bg-color: var(--el-fill-color-blank);
    --el-input-icon-color: var(--el-text-color-placeholder);
    --el-input-placeholder-color: #c9c9c9;
    --el-input-hover-border-color: #eef6f6f6ebeb;
    --el-input-clear-hover-color: var(--el-text-color-secondary);
    --el-input-focus-border-color: #f6f6f6;
    --el-input-width: 100%;
}
</style>
